import React from 'react';
import { Link } from 'react-router-dom';
import translate from 'i18n/translate';
import LinkBox from './LinkBox';

export default function LinksContainer() {
  return (
    <div className="child-20 goals-box links-container width100" duration={2}>
      <div className="text-box-title">
        <h1>{translate('otherServices')}</h1>
      </div>
      <div>
        {/* <LinkBox
          title="Zahtevi i Ponude"
          link="http://app.vmc.rs/public/login"
        ></LinkBox> */}
        <Link to="/vmc-klinika">
          <div className="link-box d-flex align-items-center justify-content-around">
            <h5 className="ml-3">{translate('vmcClinic')}</h5>
          </div>
        </Link>

        <Link to="/inovation-pool">
          <div
            className={`link-box d-flex align-items-center justify-content-around `}
          >
            <h5 className="ml-3">{translate('vcmInovationPull')}</h5>
          </div>
        </Link>
        <Link to="/vmc-forum">
          <div className="link-box d-flex align-items-center justify-content-around">
            <h5 className="ml-3">{translate('vmcBusinessForum')}</h5>
          </div>
        </Link>
        <LinkBox
          title={translate('vmcCatalog')}
          link="https://issuu.com/tomin2/docs/katalog_vmc_2019"
        ></LinkBox>
        <LinkBox
          title={translate('vmcPresentation')}
          link="/files/VMC+presentation+en.pdf"
        ></LinkBox>
      </div>
    </div>
  );
}
